export default __webpack_public_path__ + "static/media/moon.ebc6c854.svg";